<div class="create-account">
  <app-field-email (formSubmitted)="onSubmit($event)"></app-field-email>
</div>
